import { usePromotion } from '@mc/promo-utils'

export const useGiftPagePromoHeroImage = (defaultImage: string): string => {
  const { isPromotionOn, variables } = usePromotion({ isGift: true })

  if (!isPromotionOn) {
    return defaultImage
  }

  const promoImage = variables?.gift_page_hero_image as string

  return promoImage || defaultImage
}
